
import ContainerBlockGenericType from "../ContainersBlocks/ContainerBlockGenericType";

function INA1
    ({ id, isConnectable, type, selected }) {
    return (
        <ContainerBlockGenericType
            id={id}
            isConnectable={isConnectable}
            type={type}
            selected={selected}
            flagNumber={42}
            labelBlock={'INA'}
            userConfiguration={true}
        />
    );
}
export default INA1